import _ from 'lodash';
import { t } from 'utils/localize';

export default function v_max_number(value: string, args: { num: number; message?: string }) {
  return {
    message: args.message || t('Must be < ' + args.num),
    validate: () => {
      if (!value) {
        return true;
      }
      if (!_.isNumber(Number(value))) {
        return false;
      }
      return Number(value) < args.num;
    },
  };
}
